import { SidebarItemModel } from '../Models/Layout/sidebarItemModel';
import { Settings, Person2, Article } from '@mui/icons-material';

export const maxDepartmentsAllowed = 5;
export const maxSideBarCharLength = 25;
export const maxPhonesAllowed = 5;
export const maxPortalsAllowed = 5;
export const maxEmailsAllowed = 5;
export const maxContactsAllowed = 5;
export const maxdepartmentAndPhysiciansAllowed = 5;
export const rowsPerPage = 10;
export const baseURL = window._env_.REACT_APP_BASE_URL as string;
export const debounceDelay = Number(window._env_.REACT_APP_DEBOUNCEDELAY); //in ms
export const duplicateLocationRowsPerPage = 10;
export const acceptedFileUploadTypes = [
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/msword',
];
export const maximumUploadFileSize = '2000000000';

export const custodianSteps = {
  mainInfo: 'Main Information',
  departmentInfo: 'Department Info',
  billingInfo: 'Billing Information',
  associatedCustodians: 'Associated Custodians',
};
export const appActions = {
  researchCustodians: 'View research custodians',
  viewEntities: 'View Entities',
  addEntity: 'Add Entity',
  editEntity:'Edit Entity',
  viewAssociations:'View Associations',
  addAssociations:'Add Associations',
  editAssociations:'Edit Associations',
  manageRoles: 'Manage roles',
  manageUsers: 'Manage users',
};

export const appRoutesPaths = {
  home: '/',
  notFound: '/notfound',
  unauthorized: '/unauthorized',
  entities: '/entities',
  associations: '/associations',
  addAssociations: '/associations/add',
  addAssociationsWithId: '/associations/add/:id',
  editAssociations: '/associations/edit/:id',
  disableEntity:'/disable/:id',
  researchCustodians: '/res-custodians',
  custodianDetails: '/entity/details/:id',
  editDepartment: '/departments/edit/:id',
  addDepartment: 'custodian/:custodianId/departments/insert',
  addEntity: '/entity/add',
  users: '/users',
  addUser: '/users/assign',
  editUser: '/users/edit/:id',
  roles: '/roles',
  addRole: '/roles/add',
  editRole: '/roles/edit/:id',
};

export const routesWithActions = [
  {navigateTo: appRoutesPaths.entities, actionName: appActions.viewEntities},
  {navigateTo: appRoutesPaths.associations, actionName: appActions.viewAssociations},
  {navigateTo: appRoutesPaths.addAssociations, actionName: appActions.addAssociations},
  {navigateTo: appRoutesPaths.addAssociationsWithId, actionName: appActions.addAssociations},
  {navigateTo: appRoutesPaths.editAssociations, actionName: appActions.editAssociations},
  {navigateTo: appRoutesPaths.custodianDetails,actionName: appActions.viewEntities},
  {navigateTo: appRoutesPaths.addEntity,actionName: appActions.addEntity},
  { navigateTo: appRoutesPaths.roles, actionName: appActions.manageRoles },
  { navigateTo: appRoutesPaths.addRole, actionName: appActions.manageRoles },
  { navigateTo: appRoutesPaths.editRole, actionName: appActions.manageRoles },
  { navigateTo: appRoutesPaths.users, actionName: appActions.manageUsers },
  { navigateTo: appRoutesPaths.addUser, actionName: appActions.manageUsers },
  { navigateTo: appRoutesPaths.editUser, actionName: appActions.manageUsers },
];

export const sidebarItems: SidebarItemModel[] = [
  {
    title: 'Research Custodians',
    navigateTo: appRoutesPaths.researchCustodians,
    actionName: appActions.researchCustodians,
    icon: <Article />,
    isAnonymous: true,
  },
  {
    title: 'Search Entities',
    navigateTo: appRoutesPaths.entities,
    actionName: appActions.viewEntities,
    icon: <Article />,
  },
  {
    title: 'Search Associations',
    navigateTo: appRoutesPaths.associations,
    actionName: appActions.viewAssociations,
    icon: <Article />,
  },
  {
    title: 'Manage Roles',
    navigateTo: appRoutesPaths.roles,
    actionName: appActions.manageRoles,
    icon: <Settings />,
  },
  {
    title: 'Manage Users',
    navigateTo: appRoutesPaths.users,
    actionName: appActions.manageUsers,
    icon: <Person2 />,
  },
];

export const emptyValue = '-';
